<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="Sub account" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div  @click="goSellerAccountList">
            <mt-cell title="Account list">
                <i class="iconfont">&#xe650;</i>
            </mt-cell>
        </div>
        <div  @click="goSellerAccountGroupList">
            <mt-cell title="Account group">
                <i class="iconfont">&#xe650;</i>
            </mt-cell>
        </div>
        <div  @click="goSellerLogList">
            <mt-cell title="Account log">
                <i class="iconfont">&#xe650;</i>
            </mt-cell>
        </div>
        <div  @click="goSellerCostList">
            <mt-cell title="Shop consumption">
                <i class="iconfont">&#xe650;</i>
            </mt-cell>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Index',
  methods: {
    goSellerAccountList () {
      this.$router.push({ name: 'SellerAccountList' })
    },
    goSellerAccountGroupList () {
      this.$router.push({ name: 'SellerAccountGroupList' })
    },
    goSellerLogList () {
      this.$router.push({ name: 'SellerLogList' })
    },
    goSellerCostList () {
      this.$router.push({ name: 'SellerCostList' })
    }
  }
}
</script>

<style scoped>

</style>
